import { MailboxInfo } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { action } from 'satcheljs';

/**
 * Action dispatched when popout window tries to load smime item
 */
export const onSmimeItemAttachmentOpened = action(
    'onSmimeItemAttachmentOpened',
    (itemId: string, item: ClientItem, mailboxInfo: MailboxInfo) => ({
        itemId,
        item,
        mailboxInfo,
    })
);
